import {
    collection,
    component,
    EntityData,
    field,
    transientField,
    transientIdentifier,
    unrestricted
} from "@fedeltapointofsale/data-client";
import {ExtraReferenceData} from "../extras/extra.data";
import {MeasureReferenceData} from "../../stock/measure/measure.data";
import {AbstractSellableData} from "../sellable/sellable.data";
import {InventoryReferenceData} from "../../stock/inventory/inventory.data";

export class StockSizeData extends EntityData<StockSizeData> {
    @field measureAmt: number;
    @component measure: MeasureReferenceData;

    @transientIdentifier
    get id(): string {
        if (this.measureAmt != undefined) {
            return this.measureAmt + "-" + this.measure.measureId;
        } else {
            return undefined;
        }
    }

    set id(value: string) {
    }

    get name(): string {
        return this.measureAmt + " * " + this.measure.name;
    }

    set name(value: string) {
    }
}

export class ProductLineItemData extends EntityData<ProductLineItemData> {
    @field amount: number;
    @component inventory: InventoryReferenceData;
    @component stockSize: StockSizeData;

    @transientField cost: number;
}

export class ProductInventoryMapData extends EntityData<ProductInventoryMapData> {
    @field productId: number;
    @collection(ProductLineItemData) items: ProductLineItemData[];
}

export class ProductLineRecipeCard extends EntityData<ProductLineRecipeCard> {
    @field productId: number;
    @field recipeText: string;
    @field recipeImage: string;
}

export class ProductLineData extends AbstractSellableData<ProductLineData> {
    sellableType: string = "ProductLineData"; // allows assignment to a SellableData
    @field popup: boolean;
    @unrestricted @collection(ExtraReferenceData) extras: ExtraReferenceData[];
    @component productInventory: ProductInventoryMapData;
    @component productLineRecipeCard: ProductLineRecipeCard;
}
